// extracted by mini-css-extract-plugin
export var Card = "style-module--Card--2fhvh";
export var Banner = "style-module--Banner--1t_xn";
export var ImageWrapper = "style-module--ImageWrapper--1AqM-";
export var Image = "style-module--Image--3jfO5";
export var DescriptionWrapper = "style-module--DescriptionWrapper--PYinx";
export var Category = "style-module--Category--15CRW";
export var Title = "style-module--Title--3TRbR";
export var Details = "style-module--Details--jkVKC";
export var ReadingTime = "style-module--ReadingTime--3Wfb8";